import { STORAGE_KEYS, TokenHelper } from '@deltax/idp-api-client'

import { markEmbedMode } from './embedSession'
import { authService } from './client'

export const INTERNAL_REDIRECT_KEY = 'dx_internal_redirect'
export const AUTO_ATTEMPT_KEY = 'dx_auth_auto_attempt'
export const CALLBACK_PATH = '/callback'

export const callbackUri = (): string => window.location.origin + CALLBACK_PATH

export async function initiateAuthorize(
  redirectTarget: string,
  prompt?: string,
  sessionToken?: string,
): Promise<void> {
  sessionStorage.setItem(INTERNAL_REDIRECT_KEY, redirectTarget)
  if (sessionToken) {
    markEmbedMode()
  }
  const url = await authService.createAuthorizationUrl(
    callbackUri(),
    sessionToken ? undefined : prompt,
    import.meta.env.VITE_RESOURCE,
    sessionToken,
  )
  window.onbeforeunload = null
  window.location.href = url
}

export function hasValidAuthContext(state: string): boolean {
  const savedState = localStorage.getItem(STORAGE_KEYS.AUTH_STATE)
  const verifier = localStorage.getItem(STORAGE_KEYS.AUTH_VERIFIER)
  return !!savedState && savedState === state && !!verifier
}

export async function handleAuthCallback(code: string, state: string): Promise<string> {
  await authService.completeAuthorization(code, state, callbackUri())
  return sessionStorage.getItem(INTERNAL_REDIRECT_KEY) || '/'
}

export function getAccessToken(): string | null {
  return authService.getAccessToken()
}

export function setAccessToken(token: string): void {
  authService.setAccessToken(token)
}

export async function restoreSession(forceRefresh = false): Promise<boolean> {
  try {
    const token = authService.getAccessToken()
    if (!forceRefresh && token && !TokenHelper.isExpired(token)) {
      return true
    }
    const newToken = await authService.refreshAccessToken()
    return !!newToken
  } catch (error) {
    return false
  }
}

export async function idpLogout(postLogoutRedirect?: string): Promise<string> {
  const redirectUri = postLogoutRedirect || `${window.location.origin}/login`
  return authService.logout(redirectUri, false)
}

/**
 * @deprecated Access token is managed directly by @deltax/idp-api-client storage
 */
export function syncAccessTokenToLocalStorage(): void {
  // No-op: Library manages token storage key directly
}
